export default "__VITE_ASSET__y5NyWk41__"